const AUDIO_RANDOM_SENTENCES = [
    '강아지는 사람처럼 땀을 흘려서 시원해지는 게 아니에요.\n 더울 때 혀를 내밀고 헥헥 하면서 체온을 낮춰요.',
    '기린은 목이 길지만 목뼈의 개수는 우리와 똑같이 7개예요.\n 단지 그 뼈 하나하나가 엄청 길어서 목이 길어 보이는 거예요.',
    '문어는 우리가 아는 빨간 피가 아니에요.\n 몸속에 구리 성분이 있어서 피가 파랗게 보여요.',
    '상어는 몸에 딱딱한 뼈가 거의 없어요.\n 대신 연골이라는 말랑말랑한 뼈로 몸이 만들어져 있어서 유연하게 헤엄칠 수 있어요.',
    '코알라의 손가락 지문은 사람의 것과 너무 닮았어요.\n 과학자들도 현미경으로 보면 구분하기 어려울 정도예요.',
    '달팽이는 입 안에 아주 작은 이빨이 수천 개나 있어요.\n 그래서 음식을 잘게 갈아서 먹을 수 있답니다.',
    '벌은 친구들에게 꿀이 여기 있어! 라고 알려주고 싶을 때 춤을 춰요.\n 이 춤은 8자 모양으로 빙글빙글 돌면서 알려주는 신호예요.',
    '바다거북은 자기가 태어난 해변을 평생 기억해요.\n 그래서 시간이 많이 지나도 다시 그곳으로 돌아와 알을 낳는 거예요.',
    '개구리의 혀는 입 앞쪽에 붙어 있어서 아주 특별해요.\n 그래서 벌레가 지나가면 혀가 쏙 앞으로 튀어나와서 재빠르게 잡을 수 있어요.',
    '펭귄은 새이지만 날개로 하늘을 날 수는 없어요.\n 대신 물속에서는 마치 새가 날듯이 날개를 퍼덕이며 빠르게 수영해요.',
    '금일은 오늘이라는 뜻이에요.\n 어떤 사람들은 금요일이라고 착각하기도 하지만 사실은 바로 지금, 오늘을 말하는 거예요.',
    '작일은 어제라는 뜻이에요.\n 조금 낯설게 들리지만 그냥 어제라고 말하면 더 알기 쉽고 편해요.',
    '우천시는 비가 오는 날이라는 뜻이에요.\n 그러니까 "우천시 운동장을 사용하지 않습니다" 라고 하면, 비가 오면 운동장을 못 쓴다는 뜻이 되는 거예요.',
    '익일은 내일이라는 뜻이에요.\n 그래서 택배가 익일 도착합니다 라고 하면, 택배가 내일 도착한다는 말이 되는 거예요.',
    '금주는 이번 주라는 뜻이에요.\n 그래서 금주 토요일에 소풍을 갑니다 라고 하면, 이번 주 토요일에 소풍을 간다는 말이에요.',
    '차주는 다음 주라는 뜻이에요.\n 차주 월요일에 회의가 있습니다 라고 하면, 다음 주 월요일에 회의가 있다는 뜻이 되는 거예요.',
];

export const getRandomSentence = () =>
    AUDIO_RANDOM_SENTENCES[
        Math.floor(Math.random() * AUDIO_RANDOM_SENTENCES.length)
    ];
